/**
 * Keeps the Accounting list from going back in time. The page can have two reads of the same tab in
 * flight (opening the tab, then a re-read after someone changes a status); if the older one answers
 * last, a shipment that already moved to another tab would reappear. Only the newest read per tab
 * may update the list.
 */
export const createLatestTabRead = () => {
    const newest = {};
    return {
        /** Call before sending a read; returns the ticket to check when the response arrives. */
        start: (tab) => {
            newest[tab] = (newest[tab] ?? 0) + 1;
            return newest[tab];
        },
        /** True when no newer read of the same tab was sent after this one. */
        isLatest: (tab, ticket) => newest[tab] === ticket,
    };
};
